import React from 'react';
import { hoc } from 'src/core';
import { useSummaryProps } from './summary.props';
import styles from './summary.module.scss';

/**
 * <Summary />
 */
const Summary = hoc(useSummaryProps, ({ caption, lastPageText }) => (
  <div className={styles.summary}>
    <div className={styles.content}>
      <div className={styles.caption}>
        {caption ? (
          <div
            dangerouslySetInnerHTML={{
              __html: `${lastPageText.caption} <span class='${styles.heart}' role='img' aria-label='heart'>❤️</span>`
            }}
          />
        ) : (
          'Дякуємо!'
        )}
      </div>
      <div className={styles.description}>
         {lastPageText.description ? (
          <div dangerouslySetInnerHTML={{ __html: lastPageText.description }} />
        ) : (
          ''
        )}
    </div>
      </div>
  </div>
));

export { Summary };
